module.exports = __webpack_public_path__ + "img/LogotipoEmpresa.4af9598a.png";